module.exports = __webpack_public_path__ + "img/reverseTrapezoid.d3c7591d.svg";